var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","items":_vm.eventTypes,"label":_vm.$t('message.select_event_type'),"item-text":"name","item-value":"value","hide-details":true,"clearable":true},on:{"input":event => { _vm.emitChange(event) }},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }